module.exports = __webpack_public_path__ + "static/media/om_nose_turnedup.57314419.png";